import { SafeUrl } from '@angular/platform-browser';

export class FileUtility {
    public static unlinkFileUrl = (fileUrl: SafeUrl) => window.URL.revokeObjectURL((fileUrl as any).changingThisBreaksApplicationSecurity);
}
